import trackEvent from './trackEvent';

export default function trackPageView(tag) {
  if (process.env.NODE_ENV === 'development' && (typeof (tag) === 'undefined' || tag === '' || tag === null)) {
    throw new Error('Dev Error: Must pass a tag to trackPageView.');
  }

  trackEvent(tag, 'Unable to track page view.');
}
